/**
 * As of now, document template will only fill the electronic signature use-case
 * In the long run, we might generate other check type ("automated_document" check, or custom "case_report")
 */
export const DocumentTemplateTypeEnum = {
  electronic_signature: 'electronic_signature',
  // Later
  // case_report: 'case_report',
  // automated_document: 'automated_document',
} as const;
export type DocumentTemplateTypeEnum =
  (typeof DocumentTemplateTypeEnum)[keyof typeof DocumentTemplateTypeEnum];
